import gql from "graphql-tag";

export const OC_PERMIT_SUBSCRIPTION = gql`
  subscription permit {
    permit {
      _id
      requestedAt
      permittedAt
      permittedBy
      cancelledAt
    }
  }
`;
